/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbInscriptionMasseGridDto } from './FcbInscriptionMasseGridDto';
import {
    FcbInscriptionMasseGridDtoFromJSON,
    FcbInscriptionMasseGridDtoFromJSONTyped,
    FcbInscriptionMasseGridDtoToJSON,
} from './FcbInscriptionMasseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbInscriptionMasseGridDtoPaginatedResults
 */
export interface FcbInscriptionMasseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbInscriptionMasseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbInscriptionMasseGridDto>}
     * @memberof FcbInscriptionMasseGridDtoPaginatedResults
     */
    results?: Array<FcbInscriptionMasseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbInscriptionMasseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbInscriptionMasseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbInscriptionMasseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbInscriptionMasseGridDtoPaginatedResultsFromJSON(json: any): FcbInscriptionMasseGridDtoPaginatedResults {
    return FcbInscriptionMasseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbInscriptionMasseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbInscriptionMasseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbInscriptionMasseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbInscriptionMasseGridDtoPaginatedResultsToJSON(value?: FcbInscriptionMasseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbInscriptionMasseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

